// extracted by mini-css-extract-plugin
export default {"content":"InviteMessage_content__Y91kC","textArea":"InviteMessage_textArea__EdZ6F"};